import type { Group, Scene } from 'three';
import { trafficMesh } from '../entities/vehicles/catalog';
import { oppositeLaneX } from '../world/road/roadLayout';
import type { OncomingCar } from './RunState';

/** One mesh per car on the far carriageway, nose pointing at us. */
export class OncomingView {
  private readonly meshes = new Map<number, Group>();

  constructor(private readonly scene: Scene) {}

  sync(cars: readonly OncomingCar[]): void {
    const alive = new Set<number>();
    for (const car of cars) {
      alive.add(car.id);
      let mesh = this.meshes.get(car.id);
      if (!mesh) {
        mesh = trafficMesh(car.kind, car.variant);
        this.meshes.set(car.id, mesh);
        this.scene.add(mesh);
      }
      mesh.position.set(oppositeLaneX(car.lane), 0, -car.s);
      mesh.rotation.y = Math.PI;
    }
    for (const [id, mesh] of this.meshes) {
      if (alive.has(id)) continue;
      this.scene.remove(mesh);
      this.meshes.delete(id);
    }
  }

  clear(): void {
    for (const mesh of this.meshes.values()) this.scene.remove(mesh);
    this.meshes.clear();
  }
}
